// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3X154","questions":"styles_questions__12Z6l","footer":"styles_footer__1aKPP"};